import { useMutation, useQueryClient } from "@tanstack/react-query"
import * as rejEmailService from "../service/RejectionEmail"
import useShowError from "./useShowError"
import useShowToast from "./useShowToast"
import { RejectionEmailCreateRequest, Body_update_rejection_email_branding_rejection_email_rejectionemail_branding_put } from "../api/generated"

export const usePostRejectionEmailContent = () => {
    const showError = useShowError()
    const showToast = useShowToast()
  
    return useMutation({
      mutationFn: ({ opco_id, template_content, email_subject }: RejectionEmailCreateRequest) =>
        rejEmailService.postRejEmailContent({ opco_id, template_content, email_subject }),
      onSuccess() {
        showToast("Rejection email content has been successfully submitted")
      },
      onError(error) {
        showError(`Failed to send data: ${error.message}`)
      },
    })
}

export const uploadTemplateLogo = () => {
  return useMutation({
    mutationFn: ({opcoId, branding_image}: {opcoId: string, branding_image: Blob}) => {
      return rejEmailService.uploadLogo(opcoId, {
        branding_image: branding_image
      },)
    },
  })
}

  